import { useState, useEffect, useCallback } from 'react';
import { GetByIdSolicitacaoParaVisualizacao } from '@services/Solicitacao/Index.jsx';
import { mapTemplate } from '@utils/Index';

export function useFetchDataSolicitacaoByIdForView(id) {
  const [solicitacaoFields, setSolicitacaoFields] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 1) fetchData exposto como refetch
  const fetchData = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const response = await GetByIdSolicitacaoParaVisualizacao(id);
      if (!response || typeof response !== 'object') {
        console.error(
          "Erro ao buscar solicitação",
          `Nenhuma solicitação encontrada para id: ${id}.`
        );
        setSolicitacaoFields(null);
        return null;
      }

      // se vier array, pega o primeiro, se vier objeto direto, usa ele
      const s = Array.isArray(response) ? response[0] : response;
      if (!s) {
        setSolicitacaoFields(null);
        return null;
      }

      const mapped = {
        id: s.id,
        numeroSolicitacao: s.numeroSolicitacao,
        dataSolicitacao: s.dataSolicitacao?.split('T')[0],
        dataAgendarEnvio: s.dataAgendarEnvio?.split('T')[0] ?? null,
        dataLimiteSolicitacao: s.dataLimiteSolicitacao.split('T')[0],
        prazoSolicitacao: typeof s.prazoSolicitacao === 'number' ? s.prazoSolicitacao : null,
        criadoPorUsuario: s.criadoPorUsuario,
        etapaProcesso: s.etapaProcesso,
        formularioAssociadoProcesso: s.formularioAssociadoProcesso,
        formularioRespostaProcesso: s.formularioRespostaProcesso,
        unidadeGerencia: {
          id: s.unidadeGerencia?.id,
          nome: s.unidadeGerencia?.nome,
          sigla: s.unidadeGerencia?.sigla,
          nomeGerente: s.unidadeGerencia?.nomeGerente,
          nomeEncarregado: s.unidadeGerencia?.nomeEncarregado,
        },
        auditor: {
          value: s.auditor?.id,
          label: s.auditor?.nome,
        },
        emailCC: s.emailCC ?? null,
        observacoes: s.observacoes ?? null,
        statusSolicitacao: s.statusSolicitacao, // ENUM NO FORMATO STRING
        numeroStatusSolicitacao: s.numeroStatusSolicitacao, // ENUM NO FORMATO INT
        templateEmailComunicado: mapTemplate(s.templateEmailComunicado),
        templateEmailSolicitacao: mapTemplate(s.templateEmailSolicitacao),
        templateEmailRelatorio: mapTemplate(s.templateEmailRelatorio),
        compliance: {
          id: s.compliance?.id,
          codigo: s.compliance?.codigo,
          dataCriacao: s.compliance?.dataCriacao?.split('T')[0],
          tipoCompliance: s.compliance?.tipoCompliance,
          ano: s.compliance?.ano,
          tipoServico: s.compliance?.tipoServico,
          flagAuditoria: s.compliance?.flagAuditoria,
          tipoServicoAssociado: s.compliance?.tipoServicoAssociado,
          idProcesso: s.compliance?.idProcesso,
          nomeProcesso: s.compliance?.nomeProcesso,
          codigoProcesso: s.compliance?.codigoProcesso,
        },
        solicitacaoProcessoItems: s.solicitacaoProcessoItems,
      };
      console.log(mapped)

      const json = JSON.stringify(mapped);
      const tamanhoEmBytes = new TextEncoder().encode(json).length;

      setSolicitacaoFields(mapped);
      return mapped;
    } catch (err) {
      console.error("Erro ao buscar solicitação por ID:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  // 2) dispara no mount
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 3) expõe refetch para uso externo
  return {
    solicitacaoFields,
    loading,
    error,
    refetch: fetchData
  };
}